import { render, staticRenderFns } from "./CustomIcon.vue?vue&type=template&id=7f3e9324&scoped=true"
import script from "./CustomIcon.vue?vue&type=script&lang=ts"
export * from "./CustomIcon.vue?vue&type=script&lang=ts"
import style0 from "./CustomIcon.vue?vue&type=style&index=0&id=7f3e9324&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f3e9324",
  null
  
)

export default component.exports